import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoUserAvatar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 31,
	height: 30,
	viewBox: "0 0 31 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.5 24V22.75C6.5 20.4294 7.44821 18.2038 9.13604 16.5628C10.8239 14.9219 13.1131 14 15.5 14M15.5 14C17.8869 14 20.1761 14.9219 21.864 16.5628C23.5518 18.2038 24.5 20.4294 24.5 22.75V24M15.5 14C16.864 14 18.1721 13.4732 19.1365 12.5355C20.101 11.5979 20.6429 10.3261 20.6429 9C20.6429 7.67392 20.101 6.40215 19.1365 5.46447C18.1721 4.52678 16.864 4 15.5 4C14.136 4 12.8279 4.52678 11.8635 5.46447C10.899 6.40215 10.3571 7.67392 10.3571 9C10.3571 10.3261 10.899 11.5979 11.8635 12.5355C12.8279 13.4732 14.136 14 15.5 14Z",
		stroke: "#F9F8FF",
		strokeOpacity: .5,
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIcoUserAvatar;
